import { LeadStatus } from "../../models/Lead";
import Tooltip from "../shared/Tooltip";

// export enum LeadStatus {
//   "Awaiting Contact",
//   "Scheduled",
//   "Cancelled",
//   "Reschedule",
//   "Collected",
//   "Awaiting Payment",
//   "Awaiting COD",
//   "Customer to Call Back",
//   "Completed",
//   "All",
// }


export default function LeadStatusCell({ status }: { status: LeadStatus }) {
  var className = "rounded-full px-3 py-1 text-xs font-semibold ";
  switch (status) {
    case LeadStatus["Awaiting Contact"]:
      className += "bg-gray-100 text-gray-800";
      break;
    case LeadStatus.Scheduled:
      className += "bg-blue-100 text-blue-600";
      break;
    case LeadStatus.Cancelled:
      className += "bg-red-100 text-red-600";
      break;
    case LeadStatus.Reschedule:
      className += "bg-yellow-100 text-yellow-600";
      break;
    case LeadStatus.Collected:
      className += "bg-purple-100 text-purple-600";
      break;
    case LeadStatus["Awaiting Payment"]:
      className += "bg-pink-100 text-pink-600";
      break;
    case LeadStatus["Awaiting COD"]:
      className += "bg-indigo-100 text-indigo-600";
      break;
    case LeadStatus["Customer to Call Back"]:
      className += "bg-teal-100 text-teal-600";
      break;
    case LeadStatus.Completed:
      className += "bg-green-200 text-green-600";
      break;
    case LeadStatus.All:
      className += "bg-gray-300 text-gray-600";
      break;
    case LeadStatus["Call List 1"]:
      className += "bg-orange-100 text-orange-700";
      break;
  }

  return <div className="flex justify-center items-center flex-1 text-nowrap">
    <span title="Lead Status">
      <Tooltip content={"Lead Status"}>
        <span className={className}>{LeadStatus[status]}</span>
      </Tooltip>
    </span>
  </div>
};